var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExamsEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 11 4"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3977F4",
  d: "M10.849.42V3.83H.289V.42h10.56Z"
})));
export { SvgExamsEmpty as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDExIDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMC44NDkgMC40MjA2NDVWMy44Mjg2NEgwLjI4OTAxNlYwLjQyMDY0NUgxMC44NDlaIiBmaWxsPSIjMzk3N0Y0Ii8+Cjwvc3ZnPgo=";